import { SportsRequest, DateRange, EventsCountByTagRequest } from "sb-bff-integration";
export var preLiveSportBFFQueryFactoryConstructor = function (dateFactory) {
    return function () { return ({
        eventState: SportsRequest.EventStateEnum.PreLive,
        dateRange: {
            from: new dateFactory(),
            timeRange: DateRange.TimeRangeEnum.SixHours,
        }
    }); };
};
export var liveSportBFFQueryFactory = function () {
    return {
        eventState: SportsRequest.EventStateEnum.Live,
    };
};
export var todayLiveStreamingQueryFactory = function (from) { return preLiveLiveStreamingQueryFactory(from, DateRange.TimeRangeEnum.OneDay); };
export var upcomingLiveStreamingQueryFactory = function (from) { return preLiveLiveStreamingQueryFactory(from, DateRange.TimeRangeEnum.SixHours); };
var preLiveLiveStreamingQueryFactory = function (from, range) {
    return {
        eventTags: [EventsCountByTagRequest.EventTagsEnum.LiveStreaming],
        eventState: EventsCountByTagRequest.EventStateEnum.PreLive,
        eventTypes: [EventsCountByTagRequest.EventTypesEnum.Fixture],
        dateRange: {
            from: from,
            timeRange: range
        }
    };
};
export var liveLiveStreamingQueryFactory = function () {
    return {
        eventTags: [EventsCountByTagRequest.EventTagsEnum.LiveStreaming],
        eventTypes: [EventsCountByTagRequest.EventTypesEnum.Fixture],
        eventState: EventsCountByTagRequest.EventStateEnum.Live
    };
};
export var todaySportBFFQueryFactory = function (from) {
    return {
        eventState: SportsRequest.EventStateEnum.Mixed,
        dateRange: {
            from: from,
            timeRange: DateRange.TimeRangeEnum.OneDay,
        }
    };
};
//# sourceMappingURL=SportBFFQueries.js.map